module.exports = "https://health.dajiuxing.com.cn/img/assets/deviceList/alreadyBoundicon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FdeviceList%2FalreadyBoundicon.png
// module id = CviD
// module chunks = 93